module.exports = __webpack_public_path__ + "img/positions3.b38c180a.jpg";